<template>
    <div class="EventsCarousel">
        <div class="container relative">
            <div
                class="EventsCarousel__container"
            >
                <flickity
                    ref="flickity"
                    :options="flickityOptions"
                    v-if="filteredEvents"
                >
                    <EventCardFeatured
                        v-for="(event, index) in filteredEvents.slice(0, 6)"
                        :key="index + event.title"
                        :heading="event.title"
                        :startDate="event.displayStartDate"
                        :endDate="event.displayEndDate"
                        :tag="event.productLocations"
                        :text="event.description"
                        :url="event.url"
                        :placeholder="event.placeholder"
                        :image="event.image"
                        :ratio="event.ratio"
                        buttonText="Read More"
                    >
                    </EventCardFeatured>
                </flickity>
                <div class="EventsCarousel__progress">
                    <ProgressiveCircle
                        v-for="n in filteredEvents.slice(0, 6).length"
                        :key="n"
                        :index="n - 1"
                        :active-slide="activeSlide"
                        classes="ProgressiveCircle--white"
                        @setActive="setActive"
                    />
                </div>
            </div>
        </div>
    </div>
</template>
<script>

import Flickity from './BaseCarousel.vue'
import ProgressiveCircle from './ProgressiveCircle.vue'

export default {
    name: 'EventsCarousel',
    components: {
        Flickity,
        ProgressiveCircle
    },
    props: {
        events: {
            type: Array
        },
        overrideEventsIds: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            flickityOptions: {
                initialIndex: 1,
                prevNextButtons: false,
                pageDots: false,
                wrapAround: true,
                imagesLoaded: true,
                adaptiveHeight: true,
                autoPlay: 5000,
            },
            activeSlide: 0
        }
    },
    computed: {
        filteredEvents() {
            if (this.overrideEventsIds.length) {
                let eventsToFront = [];
                let eventsDefault = [];
                this.events.map((event) => {
                    if (this.overrideEventsIds.includes(event.id)) {
                        eventsToFront.push(event);
                    } else {
                        eventsDefault.push(event);
                    }
                });
                const sortedOverrides = eventsToFront.sort((a, b) => a.timestamp - b.timestamp);
                const featuredDefault = eventsDefault.filter((e) => e.featured);
                const sortedDefault = featuredDefault.sort((a, b) => a.timestamp - b.timestamp);
                return [...sortedOverrides, ...sortedDefault];
            } else {
                const featuredEvents = this.events.filter((e) => e.featured);
                return featuredEvents.sort((a, b) => a.timestamp - b.timestamp);
            }
        }
    },
    mounted() {
        const carousel = document.querySelector('.StackedCarousel')
        const flkty = this.$refs.flickity.data(carousel)
        flkty.resize();

        flkty.on('change', () => {
            this.selectActive(carousel, flkty)
            setTimeout(() => {
                flkty.resize()
            }, 600);
        });
    },
    methods: {
        selectActive(carousel, flkty) {
            this.activeSlide = flkty.selectedIndex;
        },
        next() {
            this.$refs.flickity.next();
        },

        previous() {
            this.$refs.flickity.previous();
        },

        setActive(index) {
            this.$refs.flickity.select(index);
        }
    }
}
</script>
<style lang="scss" scoped>
    .EventsCarousel__progress {
        position: absolute;
        right: 30px;
        bottom: 50px;
    }

</style>
